import { combineReducers } from 'redux';

import theme from "./theme-reducer";

export default combineReducers({ theme });
